import Fuse from "fuse.js"

interface FilterableCompany {
	name: string
	domains?: readonly string[] | null
}

export function filterCompanies<T extends FilterableCompany>(
	companies: readonly T[],
	query: string,
): T[] {
	const unique = Array.from(new Map(companies.map((c) => [c.name, c])).values())
	if (!query.trim()) return unique

	const fuse = new Fuse(unique, {
		keys: [
			{ name: "name", weight: 2 },
			{ name: "domains", weight: 1 },
		],
		threshold: 0.3,
	})
	return fuse.search(query).map((result) => result.item)
}
